import Error404 from '@/components/errors/Error404.jsx';

export default function Route() {
    return <Error404/>;
}
